import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/GetLicenseInfo'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class GetLicenseInfoStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "GetLicenseInfoStore",
			variables: false,
		})
	}
}

export async function load_GetLicenseInfo(params) {
  await initClient()

	const store = new GetLicenseInfoStore()

	await store.fetch(params)

	return {
		GetLicenseInfo: store,
	}
}
